<template>
  <div class="dictionary-item-selector">
    <dx-drop-down-box
      v-model="treeBoxValue"
      :show-clear-button="true"
      :data-source="items"
      :readOnly="readOnly"
      :disabled="disabled"
      value-expr="id"
      display-expr="name"
      :label="label"
      labelMode="static"
      :placeholder="placeholder"
      :display-value-formatter="displayValueFormatter"
      ref="dropDownBox"
      @value-changed="onValueChanged"
      @opened="onOpened"
    >
      <template #content="{ data }">
        <div class="dropdown-content">
          <dx-tree-list
            ref="treeList"
            :data-source="items"
            :show-borders="false"
            key-expr="id"
            parent-id-expr="parent.id"
            :hover-state-enabled="true"
            :show-column-headers="false"
            :show-row-lines="false"
            :selection="{mode: 'single'}"
            :selected-row-keys="selectedItemKeys"
            @selection-changed="onSelect"
            :height="treeHeight"
            :auto-expand-all="true"
          >
            <dx-filter-row :visible="true" />
            <dx-header-filter :visible="true"/>
            <dx-scrolling mode="standard" />
            <dx-paging :enabled="false" />

            <dx-column
              data-field="name"
              :allow-header-filtering="false"
              :allow-filtering="true"
            />
          </dx-tree-list>
        </div>
      </template>

      <DxValidator>
        <DxRequiredRule :message="$t('general.mandatory')" />
      </DxValidator>
    </dx-drop-down-box>
  </div>
</template>

<script>
import { DxDropDownBox } from 'devextreme-vue';
import { DxValidator, DxRequiredRule } from 'devextreme-vue/validator';
import {
  DxTreeList,
  DxColumn,
  DxFilterRow,
  DxHeaderFilter,
  DxPaging,
  DxScrolling,
} from 'devextreme-vue/tree-list';

export default {
  name: 'dictionary-item-selector',
  props: ['readOnly', 'disabled', 'value', 'items', 'label', 'placeholder'],
  components: {
    DxDropDownBox, DxTreeList, DxColumn, DxFilterRow,
    DxHeaderFilter, DxPaging, DxScrolling, DxValidator,
    DxRequiredRule
  },
  data() {
    return {
      treeBoxValue: this.value? [this.value]: null,
      selectedItemKeys: this.value? [this.value.id]: null,
    };
  },
  computed: {
    treeHeight() {
      const height = window.innerHeight - 400;
      return height < 0? 100: height;
    }
  },
  methods: {
    onValueChanged(e) {
      this.$emit('selectedLocation', e.value);
      this.$refs.dropDownBox.instance.close();
    },
    displayValueFormatter() {
      if (this.treeBoxValue) {
        return this.treeBoxValue[0].name;
      }
    },
    onOpened() {
      if (!this.value) {
        this.$refs.treeList.instance.deselectAll();
      } else {
        this.$refs.treeList.instance.selectRows(this.value.id);
        this.$refs.treeList.instance.navigateToRow(this.value.id);
      }
    },
    onSelect(e) {
      this.treeBoxValue = e.selectedRowsData;
      this.$emit('input', e.selectedRowsData[0]);
    },
  },
  watch: {
    value(value) {
      this.treeBoxValue = value? [value]: null;
    },
    treeBoxValue(treeBoxValue) {
      if (treeBoxValue === null)
        this.$emit('input', null); // Notify value cleared
    },
  }
};
</script>

<style lang="scss" scoped>
.dictionary-item-selector {
  width: 100%;
}
.dropdown-content {
  &>.dx-textbox {
    margin-bottom: 16px;
  }
}
</style>
